import { render } from "./BaziChartRegistration.vue?vue&type=template&id=8e0c84a8&scoped=true"
import script from "./BaziChartRegistration.vue?vue&type=script&lang=js"
export * from "./BaziChartRegistration.vue?vue&type=script&lang=js"

import "./BaziChartRegistration.vue?vue&type=style&index=0&id=8e0c84a8&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontendadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0c84a8"]])

export default __exports__